/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @ngdoc service
 * @name TopWAFEnforcementsMetric
 * @description
 *
 *     Fetches one aggregated series for multiple objIds.
 */
angular.module('aviApp').factory('TopWAFEnforcementsMetric', [
'SingleSeriesPerEveryObjectMetric',
function(SingleSeriesPerEveryObjectMetric) {
    return class TopWAFEnforcementsMetric extends SingleSeriesPerEveryObjectMetric {
        constructor(args) {
            args.stackedSeries = false;// no need in total series
            super(args);
        }
    };
}]);
